const PayoutDetails = ({ selectedPayout, user }) => {
  return (
    <>
      <div onClick={(e) => e.stopPropagation()} className='payoutDetailDIv'>
        <h5 className='payoutDetailTitle8467'>{selectedPayout.product.name}</h5>
        <div className='detailsflex836483'>
          <div>
            <p>Quantity</p>
            <p>Unit price</p>
            <p>Total price</p>
            <p>Commission</p>
          </div>
          <div>
            <p>{selectedPayout.quantity} </p>
            <p>
              {user.userCountryCurrencySymbol} {selectedPayout.unitPrice}
            </p>
            <p>
              {user.userCountryCurrencySymbol} {selectedPayout.totalPrice}
            </p>
            <p>
              {user.userCountryCurrencySymbol} {Math.ceil(selectedPayout.commission)}
            </p>
          </div>
        </div>
        <div className='hrline7364'></div>

        <h5 className='payoutDetailTitle8467'>Payout </h5>
        <div className='detailsflex836483'>
          <div>
            <p>Payount amount</p>
            <p>Payout date</p>
            <p>Payout ID</p>
            <p>Payout Method</p>
          </div>
          <div>
            <p>
              {user.userCountryCurrencySymbol} {Math.floor(selectedPayout.totalPrice - selectedPayout.commission)}
            </p>
            <p>{selectedPayout.payoutDate ? selectedPayout.payoutDate : "Processing"} </p>
            <p>{selectedPayout.paymentID}</p>
            <p>{user.payoutMethod.payoutMethod}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PayoutDetails;
